import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY');
    }

    return 'Ukjent'
});

var app = new Vue({
    el: '#hummerPage',
    components: {
        PulseLoader
    },

    data: {
        hummerNumber: null,
        hummerTagData: null,
        hasSearched: false
    },

    watch: {
        hummerTagData: function (val) {
                // console.log(val);
            },
    },

    methods: {
        getHummerTagData: function () {
            var self = this;
            self.hummerTagData = null;
            axios.get('/umbraco/Surface/Statistic/GetHummermerke/', {
                params: {
                    tagNumber: self.hummerNumber,
                }
            })
                .then((response) => {
                    if (response.data !== 'error') {
                        self.hummerTagData = response.data;
                    }
                    else {
                        self.hasSearched = true;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() => {
                    self.hasSearched = true;
                });
        },
    },

    mounted() {

    }
});


// WEBPACK FOOTER //
// ./Scripts/app/hummer/index.js